import { InputProps, Input, Form } from "antd";
import { CheckOutlined } from '@ant-design/icons';


export const MyInput = (props: InputProps) => {

    const { status, errors } = Form.Item.useStatus();

    return (
        <div>
            <Input
                {...props}
                suffix={(status === 'success' && props.value) ? <CheckOutlined
                    style={{ color: '#94C185', }}
                /> : <div />}

                style={{
                    height: 50,
                    borderRadius: 5,
                    color: 'rgba(0,0,0,0.5)',
                    ...props.style || {},
                }}
                styles={
                    {
                        root: {
                            borderColor: (status === 'success' && props.value) ? '#94C185' : undefined,
                        },
                    }
                }
            />
            {props.maxLength && (
                <div
                    style={{ textAlign: 'end', position: 'absolute', right: 0 }}
                >
                    {`${(props.value as string|undefined)?.length??0}/${props.maxLength}`}
                </div>
            )}
        </div>

    )
}